export type ContactAcquisitionMode = "csv" | "search";

export type RegistrationPendingShape = {
  status: "pending_confirmation";
  email: string;
  confirmationExpiresAt: string;
  message: string;
};

export type ConfirmationPageStatus = "expired" | "inactive" | "error";

export type ConfirmationFailureInput = {
  code?: string;
  message: string;
};

export type LoginFailureInput = {
  code?: string;
  message: string;
};

export function isRegistrationPending(value: unknown): value is RegistrationPendingShape {
  return (
    typeof value === "object" &&
    value !== null &&
    "status" in value &&
    (value as { status?: unknown }).status === "pending_confirmation"
  );
}

export function confirmationFailureStatus(error: ConfirmationFailureInput): ConfirmationPageStatus {
  if (error.code === "LOCAL_AUTH_CONFIRM_EMAIL_EXPIRED") {
    return "expired";
  }

  if (error.code === "LOCAL_AUTH_CONFIRM_EMAIL_INACTIVE") {
    return "inactive";
  }

  const loweredMessage = error.message.toLowerCase();

  if (loweredMessage.includes("expired")) {
    return "expired";
  }

  if (loweredMessage.includes("no longer active")) {
    return "inactive";
  }

  return "error";
}

export function normalizeContactAcquisitionMode(value: unknown): ContactAcquisitionMode | null {
  return value === "csv" || value === "search" ? value : null;
}

export function loginFailureMessage(error: LoginFailureInput): string {
  if (error.code === "TENANT_SLUG_REQUIRED") {
    return "This email is assigned to more than one workspace. Workspace selection will be added to account management; use a single-workspace email for this prototype login.";
  }

  return error.message;
}
